/** Every instant is shown in Esther's zone, whatever zone the process runs in. */
export const DISPLAY_TIME_ZONE = "America/New_York";

const DATE_FMT = new Intl.DateTimeFormat("en-US", {
  timeZone: DISPLAY_TIME_ZONE, weekday: "short", month: "short", day: "numeric", year: "numeric",
});
const TIME_FMT = new Intl.DateTimeFormat("en-US", {
  timeZone: DISPLAY_TIME_ZONE, hour: "numeric", minute: "2-digit",
});

/** "Tue, Sep 29, 2026 at 9:14 AM" — an instant in DISPLAY_TIME_ZONE, whatever
 *  zone the process runs in. Call it on the SERVER and pass the string to a
 *  client component: a bare `toLocaleString()` produces one string in UTC during
 *  SSR and another in the browser's zone during hydration, and React throws
 *  hydration error #418 (see AdminFeedbackRow). */
export function formatDateTime(d: Date): string {
  return `${DATE_FMT.format(d)} at ${TIME_FMT.format(d)}`;
}

const DAY_KEY_FMT = new Intl.DateTimeFormat("en-CA", { timeZone: DISPLAY_TIME_ZONE, year: "numeric", month: "2-digit", day: "2-digit" });
const DAY_FMT = new Intl.DateTimeFormat("en-US", { timeZone: DISPLAY_TIME_ZONE, weekday: "short", month: "short", day: "numeric" });
const OLD_DAY_FMT = new Intl.DateTimeFormat("en-US", { timeZone: DISPLAY_TIME_ZONE, month: "short", day: "numeric", year: "numeric" });
/** "Oct 25, 2026": a day in DISPLAY_TIME_ZONE. The invite list's dates and the
 *  invitation email's expiry line share it. */
export function formatDay(d: Date): string {
  return OLD_DAY_FMT.format(d);
}
/** Days since the epoch of the calendar day `d` falls on in DISPLAY_TIME_ZONE. */
const dayNumber = (d: Date) => Date.parse(`${DAY_KEY_FMT.format(d)}T00:00:00Z`) / 86_400_000;

/** When a capture arrived, in plain words: "Today, 2:05 PM", "Yesterday, 9:14 AM",
 *  "Tue, Sep 29, 12:00 PM", or "Dec 1, 2025" from an earlier year. Server-side
 *  only, for the same hydration reason as `formatDateTime`. */
export function formatCapturedAt(d: Date, now: Date = new Date()): string {
  const days = dayNumber(now) - dayNumber(d);
  if (days === 0) return `Today, ${TIME_FMT.format(d)}`;
  if (days === 1) return `Yesterday, ${TIME_FMT.format(d)}`;
  if (DAY_KEY_FMT.format(d).slice(0, 4) !== DAY_KEY_FMT.format(now).slice(0, 4)) return OLD_DAY_FMT.format(d);
  return `${DAY_FMT.format(d)}, ${TIME_FMT.format(d)}`;
}
